import { AppLayout } from "./components/layout/AppLayout"
import { Header } from "./components/layout/Header"
import { Page } from "./components/layout/Page"
import { AwardsAndCertificates } from "./components/sections/AwardsAndCertificates"
import { Education } from "./components/sections/Education"
import { Experience } from "./components/sections/Experience"
import { Miscellaneous } from "./components/sections/Miscellaneous"
import { OpenSource } from "./components/sections/OpenSource"
import { ProfileSummary } from "./components/sections/ProfileSummary"
import { Skills } from "./components/sections/Skills"
import { PhoneProvider } from "./theme/PhoneProvider"
import { ThemeProvider } from "./theme/ThemeProvider"

function App() {
    // Chevron (experience 2) leads page 1's tail so the sheet fills; page 2
    // opens with Education
    // page-2 order: Education → Skills → Open Source → Awards → Miscellaneous
    const firstPageEndExp = 2
    const firstPageEndJob = undefined // 1, 2, 3, ... or undefined

    const showAllJobsOnFirstPage = firstPageEndJob === undefined

    return (
        <ThemeProvider>
            <PhoneProvider>
                <AppLayout>
                    <Page>
                        <Header />
                        <ProfileSummary />
                        <Experience
                            endExperience={firstPageEndExp}
                            endJobDescription={firstPageEndJob}
                        />
                    </Page>
                    <Page>
                        <Experience
                            startExperience={
                                showAllJobsOnFirstPage ? firstPageEndExp + 1 : firstPageEndExp
                            }
                            startJobDescription={showAllJobsOnFirstPage ? 0 : firstPageEndJob + 1}
                        />
                        <Education />
                        <Skills />
                        <OpenSource />
                        <AwardsAndCertificates />
                        <Miscellaneous />
                    </Page>
                </AppLayout>
            </PhoneProvider>
        </ThemeProvider>
    )
}

export default App
